<template>
  <div id="download-other-version" v-if="currentPlatform !== 'ios'">
    <!-- <a
      v-if="currentPlatform === 'windows' && windowsNetInfo"
      :href="windowsNetInfo.download_link || '#'"
      class="net"
    >{{$t('netVersion')}}{{windowsNetInfo.version_name}}</a>-->
    <!-- <a v-if='currentPlatform === "mac"' href=" https://pkg.aiaster.xyz/macos/plexqt_5.6.2.dmg" class="mac">{{$t('oldVersion')}}</a> -->
    <a v-if="stableVersionInfo" :href="stableVersionInfo.download_link || '#'">{{$t('stableVersion')}}{{stableVersionInfo.version_name}}</a>
    <a v-if="betaVersionInfo" :href="betaVersionInfo.download_link || '#'">{{$t('betaVersion')}}{{betaVersionInfo.version_name}}</a>
  </div>
</template>

<script>
import locales from './lang';
import { mapState } from 'vuex';

export default {
  name: 'download-other-version',
  locales,
  data() {
    return {
      stableVersionInfo: null,
      betaVersionInfo: null,
      windowsNetInfo: null
    };
  },
  computed: {
    ...mapState({
      currentPlatform: state => state.download.currentPlatform,
      allDownloadInfo: state => state.download.allDownloadInfo
    })
  },
  watch: {
    allDownloadInfo() {
      this.getOtherVersionHtml();
    },
    currentPlatform() {
      this.getOtherVersionHtml();
    }
  },
  methods: {
    getOtherVersionHtml() {
      const nowPlatform = this.currentPlatform || '';
      const downloadInfoObj = this.allDownloadInfo || {};
      let name = '';

      if (Object.keys(downloadInfoObj).length <= 0) {
        return '';
      }
      if (nowPlatform === 'windows') {
        name = 'win';
      } else if (nowPlatform === 'android') {
        name = 'an';
      } else if (nowPlatform === 'androidTV') {
        name = 'an-tv';
      } else if (nowPlatform === 'mac') {
        name = 'macos';
      } else if (nowPlatform === 'ubuntu') {
        name = 'linux';
      }
      this.stableVersionInfo = downloadInfoObj[`${name}-st`] || null;
      this.betaVersionInfo = downloadInfoObj[`${name}-beta`] || null;
      this.windowsNetInfo = downloadInfoObj.windows_wpf || null;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}

#download-other-version {
  width: 100%;
  a {
    display: inline-block;
    font-size: 0.16rem;
    line-height: 22px;
    color: #666;
    letter-spacing: 1px;
    text-decoration: underline;
    margin: 0.24rem 0.24rem 0 0;
    &.net, &.mac {
      font-weight: bold;
      width: 100%;
    }
  }
  @media screen and (max-width: 767px) {
    text-align: center;
    a {
      margin-right: 0;
      font-size: 14px;
      line-height: 20px;
      &:nth-child(n+2) {
        margin-top: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// DownloadOtherVersion.vue?0e341e58